import React, { useState } from 'react';
import { Drawer, List, Checkbox, Divider } from 'antd';
import CustomButton from '../../../components/CustomButton/Button';
import { formatCategoryName, formatOptionLabel } from '../../../helpers/helpers';

const FilterDrawer = ({
  open,
  onClose,
  onClear,
  onApply,
  selectedOptions,
  onOptionChange,
  onSelectAll,
  industryTypes,
  enterprises,
  roi,
  maturity,
  rating
}) => {
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState({});

  const filterData = {
    roi: roi?.length > 0 ? roi : [],
    maturity: maturity?.length > 0 ? maturity : [],
    rating: rating?.length > 0 ? rating : [],
    industryTypes: industryTypes?.length > 0 ? industryTypes : [],
    enterprises: enterprises.length > 0 ? enterprises : []
  };

  const keyMappings = {
    maturity: { idKey: 'maturityId', labelKey: 'maturityDesc' },
    roi: { idKey: 'roiId', labelKey: 'roiDesc' },
    rating: { idKey: 'ratingId', labelKey: 'ratingDesc' },
    industryTypes: { idKey: 'industryTypeId', labelKey: 'industryTypeName' },
    enterprises: { idKey: 'entId', labelKey: 'entName' },
  };

  const handleFilterSelect = (filter) => {
    setSelectedFilter(filter);
  };

  const handleSelectAll = (category) => {
    const allOptionIds = filterData[category].map((option) => option[keyMappings[category].idKey]);
    const isAllSelected = selectedOptions[category]?.length === allOptionIds.length;
    onSelectAll(category, isAllSelected ? [] : allOptionIds);
  };

  const toggleViewMore = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  return (
    <Drawer
      title="Filter"
      placement="right"
      onClose={onClose}
      open={open}
      mask={false}
      closeIcon={false}
      extra={
        <CustomButton
          type="text"
          style={{ padding: 5, color: "#294DD8", fontWeight: "bold" }}
          onClick={onClear}
        >
          CLEAR ALL
        </CustomButton>
      }
      width="100%"
      rootClassName="custom-filter-drawer"
    >
      <div className='drawer-content'>
        <List className='category-list'>
          {Object.keys(filterData).map((filter) => (
            <List.Item
              key={filter}
              onClick={() => handleFilterSelect(filter)}
              style={{
                cursor: 'pointer',
                background: selectedFilter === filter ? '#ffffff' : '#F5F8FF',
                color: selectedFilter === filter ? 'black' : "#40566D",
                fontWeight: selectedFilter === filter ? 'bold' : "400",
                padding: '16px',
              }}
            >
              {formatCategoryName(filter)}
            </List.Item>
          ))}
        </List>

        <div className='category-options-container'>
          {selectedFilter && (
            <>
              <Checkbox
                indeterminate={
                  selectedOptions[selectedFilter]?.length > 0 &&
                  selectedOptions[selectedFilter]?.length < filterData[selectedFilter].length
                }
                checked={selectedOptions[selectedFilter]?.length === filterData[selectedFilter].length}
                onChange={() => handleSelectAll(selectedFilter)}
                style={{ marginBottom: '15px', fontWeight: "bold" }}
              >
                Select All
              </Checkbox>

              <Checkbox.Group
                value={selectedOptions[selectedFilter]}
                onChange={(checkedValues) => onOptionChange(selectedFilter, checkedValues)}
                className='category-options'
              >
                {filterData[selectedFilter].slice(0, expandedCategories[selectedFilter] ? filterData[selectedFilter].length : 10)
                  .map((option) => (
                    <Checkbox key={option[keyMappings[selectedFilter].idKey]} value={option[keyMappings[selectedFilter].idKey]}>
                      {formatOptionLabel(selectedFilter, option[keyMappings[selectedFilter].labelKey])}
                    </Checkbox>
                ))}
              </Checkbox.Group>

              {filterData[selectedFilter].length > 10 && (
                <CustomButton
                  type="text"
                  style={{ padding: 5, color: "#294DD8", fontWeight: "bold", marginTop: '10px' }}
                  onClick={() => toggleViewMore(selectedFilter)}
                >
                  {expandedCategories[selectedFilter] ? 'View Less' : 'View More'}
                </CustomButton>
              )}
            </>
          )}
        </div>
      </div>

      {/* Drawer Footer with Close and Apply Buttons */}
      <div className="drawer-footer">
        <CustomButton
          color="danger"
          variant="text"
          block
          style={{ fontWeight: "bold" }}
          onClick={onClose}
        >
          CLOSE
        </CustomButton>
        <Divider type='vertical' className='footer-btn-divider' />
        <CustomButton
          color="primary"
          variant="text"
          block
          style={{ fontWeight: "bold" }}
          onClick={onApply}
        >
          APPLY
        </CustomButton>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
